import React, { useRef, useState, useCallback } from 'react';
import { scanDoc } from '../services/api';
import './Scan.css';

export default function Scan({ onResult }) {
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [statusMsg, setStatusMsg] = useState('');
  const [erro, setErro] = useState(null);

  const handleCapture = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile(file);
    setErro(null);
    const reader = new FileReader();
    reader.onload = (ev) => setPreview(ev.target.result);
    reader.readAsDataURL(file);
  };

  const handleScan = useCallback(async () => {
    if (!imageFile) return;
    setProcessing(true);
    setErro(null);

    const steps = [
      'A ler o documento...',
      'A extrair texto com OCR...',
      'A identificar campos...',
      'Quase pronto...'
    ];
    let i = 0;
    setStatusMsg(steps[0]);
    const interval = setInterval(() => {
      i++;
      if (i < steps.length) setStatusMsg(steps[i]);
    }, 900);

    try {
      const formData = new FormData();
      formData.append('imagem', imageFile);
      const res = await scanDoc(formData);
      clearInterval(interval);
      onResult({ imagem: imageFile, preview, ...res.data });
    } catch (err) {
      clearInterval(interval);
      setErro('Erro ao processar. Tenta com melhor iluminação.');
    } finally {
      setProcessing(false);
    }
  }, [imageFile, preview, onResult]);

  const handleReset = () => {
    setPreview(null);
    setImageFile(null);
    setErro(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  return (
    <div className="scan-page">
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleCapture}
        style={{ display: 'none' }}
        id="camera-input"
      />

      {processing && (
        <div className="scan-processing">
          <div className="scan-spinner" />
          <p className="scan-status">{statusMsg}</p>
        </div>
      )}

      {!processing && !preview && (
        <div className="scan-empty">
          <div className="viewfinder">
            <div className="vf-corner tl" />
            <div className="vf-corner tr" />
            <div className="vf-corner bl" />
            <div className="vf-corner br" />
            <span className="vf-hint">Centra o documento aqui</span>
          </div>
          <label htmlFor="camera-input" className="capture-btn">
            <span>◎</span>
            Fotografar documento
          </label>
          <label htmlFor="camera-input" className="gallery-btn">
            Escolher da galeria
          </label>
        </div>
      )}

      {!processing && preview && (
        <div className="scan-preview">
          <img src={preview} alt="Documento capturado" className="preview-img" />
          {erro && <p className="scan-erro">{erro}</p>}
          <div className="preview-actions">
            <button className="preview-retry" onClick={handleReset}>
              Nova foto
            </button>
            <button className="preview-confirm" onClick={handleScan}>
              Fazer OCR →
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
